module.exports = __webpack_public_path__ + "static/img/tst2-01-1.2b762d0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-01-1.gif
// module id = rLCI
// module chunks = 1